import { IntegrationApiMasterdataCore } from "@acrevis/integration-api-masterdata-core";
import {
  accessTokenRef as rentalDepositBackendAccessTokenRef,
  createRentalDepositGraphqlClient,
  isAuthenticatedRef as rentalDepositBackendIsAuthenticatedRef,
} from "@acrevis/rental-deposit-graphql-client";
import { ApolloClients, provideApolloClients } from "@vue/apollo-composable";
import type { App } from "vue";
import { inject, provide, watch } from "vue";

import { apiConfig } from "@/core/config";
import oidcAuth from "@/oidc";

export const APOLLO_CLIENT_NAMES = {
  DEFAULT: "default",
};

// Masterdata API

export const integrationApiMasterdataCoreConfig = new IntegrationApiMasterdataCore({
  BASE: apiConfig.masterdata.api,
  TOKEN: oidcAuth.accessToken,
});

const countriesMasterdataApiSymbol = Symbol("CountriesMasterdataApi");
const countriesMasterdataApiClient = integrationApiMasterdataCoreConfig.countries;
export const provideCountriesMasterdataApi = () => provide(countriesMasterdataApiSymbol, countriesMasterdataApiClient);
export const provideCountriesMasterdataApiMethod = (provide: App["provide"]) =>
  provide(countriesMasterdataApiSymbol, countriesMasterdataApiClient);
export const useCountriesMasterdataApi = () => inject(countriesMasterdataApiSymbol, countriesMasterdataApiClient);

const zipCitiesMasterdataApiSymbol = Symbol("ZipCitiesMasterdataApi");
const zipCitiesMasterdataApiClient = integrationApiMasterdataCoreConfig.zipCities;
export const provideZipCitiesMasterdataApi = () => provide(zipCitiesMasterdataApiSymbol, zipCitiesMasterdataApiClient);
export const provideZipCitiesMasterdataApiMethod = (provide: App["provide"]) =>
  provide(zipCitiesMasterdataApiSymbol, zipCitiesMasterdataApiClient);
export const useZipCitiesMasterdataApi = () => inject(zipCitiesMasterdataApiSymbol, zipCitiesMasterdataApiClient);

watch(
  () => oidcAuth.accessToken,
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  () => (rentalDepositBackendAccessTokenRef.value = oidcAuth.accessToken),
);
watch(
  () => oidcAuth.isAuthenticated,
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  () => (rentalDepositBackendIsAuthenticatedRef.value = oidcAuth.isAuthenticated),
);

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
export const backendApiClient = createRentalDepositGraphqlClient(apiConfig.backend.api);

export const provideApis = (provideFunc: App["provide"]) => {
  provideCountriesMasterdataApiMethod(provideFunc);
  provideZipCitiesMasterdataApiMethod(provideFunc);
  const clients = {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    [APOLLO_CLIENT_NAMES.DEFAULT]: backendApiClient,
  };
  provideApolloClients(clients);
  provideFunc(ApolloClients, clients);
};
